import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthGate from './components/AuthGate';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import PartyChats from './pages/PartyChats';
import Friends from './pages/Friends';
import Games from './pages/Games';
import Inbox from './pages/Inbox';
import Presence from './pages/Presence';
import ProfileInspector from './pages/ProfileInspector';

function App() {
  return (
    <AuthGate>
      <Router>
        <div className="min-h-screen bg-background text-foreground">
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/party-chats" element={<PartyChats />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/games" element={<Games />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/presence" element={<Presence />} />
              <Route path="/profile-inspector" element={<ProfileInspector />} />
            </Routes>
          </Layout>
        </div>
      </Router>
    </AuthGate>
  );
}

export default App;
